import { useCallback, useMemo } from 'react';
import { AccountPlan } from '@/constants/enum';
import { PLAN_DISPLAY_NAME } from '@/constants/plan';
import { capitalizeFirstLetter } from '@/helpers';
import { useGetUserPlanQuery } from '@/redux/api/api.caller';

export const usePlanDisplayName = () => {
  const { data } = useGetUserPlanQuery({});

  const nameByPlan = useMemo(() => {
    const result: Partial<Record<AccountPlan, string>> = {};
    data?.data?.allPlans?.forEach(({ plan, displayName }) => {
      const name = displayName?.trim();
      if (name) result[plan] = name;
    });
    return result;
  }, [data]);

  const getPlanName = useCallback(
    (plan?: AccountPlan | string): string => {
      const key = plan as AccountPlan;
      const name = nameByPlan[key] || PLAN_DISPLAY_NAME[key] || PLAN_DISPLAY_NAME[AccountPlan.Starter];
      return capitalizeFirstLetter(name);
    },
    [nameByPlan],
  );

  const displayPlan = data?.data?.billingSummary?.displayPlan?.trim();
  const currentPlanName = displayPlan ? capitalizeFirstLetter(displayPlan) : getPlanName(data?.data?.plan);

  return { getPlanName, currentPlanName };
};
